import { COLORS, FlexView } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import React from 'react';
import styled from 'styled-components';
import useLogic from './TeacherRetentionFormula.logic';
import { TEACHER_PERFORMANCE_STATES_CONFIG } from 'constants/teacher-details';
import LAYOUT from 'constants/layout';

const Divider = styled(FlexView)`
  height: 2px;
  width: 28px;
  margin: 2px;
  background-color: ${COLORS.GRAY_XLIGHT};
`;
const EquationWrapper = styled(FlexView)`
  margin-top: 2px;
`;
const FormulaLabel = styled(Text)`
  font-size: ${LAYOUT.FONT_SMALL}px;
`;

const TeacherRetentionFormula = () => {
  const { retentionFormula, retentionRate, performanceState } = useLogic();

  const { numerator, denominator } = retentionFormula ?? {};

  return !TEACHER_PERFORMANCE_STATES_CONFIG?.[performanceState]?.hideRetentionRate &&
    performanceState ? (
    <FlexView>
      <FlexView flexDirection="row" alignItems="center" justifyContent="space-between">
        <FormulaLabel variant="cta2">Retention rate</FormulaLabel>
        <FormulaLabel variant="cta2">=</FormulaLabel>
        <EquationWrapper alignItems="center">
          <FormulaLabel variant="cta2">{` ${numerator?.key ?? '--'} `}</FormulaLabel>
          <Divider />
          <FormulaLabel variant="cta2">{denominator?.key ?? '--'} </FormulaLabel>
        </EquationWrapper>
        <FormulaLabel variant="cta2">x </FormulaLabel>
        <FormulaLabel variant="cta2">100 </FormulaLabel>
        <FormulaLabel variant="cta2"> = </FormulaLabel>
        <EquationWrapper alignItems="center">
          <FormulaLabel variant="cta2">{numerator?.value}</FormulaLabel>
          <Divider />
          <FormulaLabel variant="cta2">{denominator?.value}</FormulaLabel>
        </EquationWrapper>
        <FormulaLabel variant="cta2"> x </FormulaLabel>
        <FormulaLabel variant="cta2"> 100 </FormulaLabel>
        <FormulaLabel variant="cta2"> = </FormulaLabel>
        <FormulaLabel variant="cta2"> {retentionRate}%</FormulaLabel>
      </FlexView>
    </FlexView>
  ) : null;
};

export default TeacherRetentionFormula;
